/**
 * Shared layout vocabulary for the container atoms (<Row>, <Stack>).
 *
 * Consumers use short, prefix-free values (`start`, `end`, `between`, …); these
 * maps translate them to the React Native flexbox strings so the RN detail never
 * leaks into the DS prop surface.
 */
import type { FlexStyle } from "react-native"

export type Justify = "start" | "center" | "end" | "between" | "around" | "evenly"
export type Align = "start" | "center" | "end" | "stretch" | "baseline"

export const justifyMap: Record<Justify, FlexStyle["justifyContent"]> = {
    start: "flex-start",
    center: "center",
    end: "flex-end",
    between: "space-between",
    around: "space-around",
    evenly: "space-evenly",
}

export const alignMap: Record<Align, FlexStyle["alignItems"]> = {
    start: "flex-start",
    center: "center",
    end: "flex-end",
    stretch: "stretch",
    baseline: "baseline",
}
